<template>
  <div class="legal-tender-set main-second-bg">
    <p class="user-management-child-header b-1-cl a-3-bd">
      {{ $t("personal.leaglTenderSet.title") }}
    </p>
    <div class="user-management-main clearfix">
      <ul class="ul">
        <li class="li clearfix">
          <!--icon占位用-->
          <svg-icon class="li-icon icon icon-24" icon-class="icon-reseveMethod"></svg-icon>
          <div class="li-div li-divs a-3-bd b-1-cl clearfix">
            <p class="li-title">
              {{ $t("personal.leaglTenderSet.titleList")[0].text }}
            </p>
            <p class="li-text b-2-cl">
              {{ $t("personal.leaglTenderSet.titleList")[0].label }}
            </p>
            <div class="li-right clearfix">
              <c-button
                type="solid"
                :big="true"
                className="user-button"
                paddingW="18px"
                height="30px"
                @click="btnLink('setUp')"
                >{{
                  dataList.length === 0 ? $t("personal.tool.setUp") : $t("personal.tool.add")
                }}</c-button
              >
            </div>
          </div>
        </li>
        <li class="li clearfix" v-for="obj in dataList" :key="obj.id">
          <div class="li-div li-div-right a-3-bd b-1-cl clearfix">
            <p class="li-title">
              <c-otcPayIcon :imgUrl="obj.icon" className="otcPayIconClass" />
              {{ obj.title }}
              <span
                class="carp-coin"
                v-if="excheifFlag && obj.payment === 'otc.payment.domestic.bank.transfer'"
              >
                {{ obj.coinName }}</span
              >
            </p>
            <p class="li-text subTextIndent b-2-cl" v-html="resloveText(obj)"></p>
            <div class="li-right clearfix">
              <c-switch-big
                style="transform: translate(0, -10px)"
                :value="Boolean(obj.isOpen)"
                @click="switchChange(`${obj.id}`, `${obj.isOpen}`)"
              />
              <c-button
                className="li-fun b-4-cl clearfix"
                type="text"
                @click="click(`${obj.id}`, 'delete')"
              >
                {{ $t("personal.tool.delete") }}
              </c-button>
              <c-button
                className="li-fun b-4-cl clearfix"
                type="text"
                @click="click(obj, 'modify')"
              >
                {{ $t("personal.tool.modify") }}
              </c-button>
            </div>
          </div>
        </li>
        <!-- 资金密码 -->
        <!-- <li class="li clearfix">
          <svg-icon class="li-icon icon icon-24" icon-class="icon-asset-password"></svg-icon>
          <div class="li-div li-divs a-3-bd b-1-cl clearfix">
            <p class="li-title">
              {{ $t("personal.leaglTenderSet.titleList")[1].text }}
            </p>
            <p class="li-text b-2-cl">
              {{ $t("personal.leaglTenderSet.titleList")[1].label }}
            </p>
            <div class="li-right clearfix">
              <c-button
                v-if="isCapitalPwordSet === 0"
                type="solid"
                :big="true"
                className="user-button"
                paddingW="18px"
                height="30px"
                @click="btnLink('modifySettings')"
                >{{ $t("personal.tool.setUp") }}</c-button
              >
              <c-button
                v-else
                paddingW="18px"
                height="30px"
                className="user-button"
                @click="btnLink('modifySettings')"
              >
                {{ $t("personal.tool.modify") }}
              </c-button>
            </div>
          </div>
        </li> -->
      </ul>
    </div>
    <!-- 提示框 -->
    <c-alert
      :showFlag="alertFlag"
      :buttonText="this.$t('personal.alert.certif')"
      imageType="1"
      :imgMap="imgMap"
      :colorMap="colorMap"
      @close="alertClose"
      @confirm="alertGo"
      :title="fiatTradeOpen ? $t('assets.b2c.otcShow.fiatTitle') : $t('personal.alert.fiatTitle')"
    >
      <!-- <div class="alertTitle b-1-cl">
        {{ fiatTradeOpen ? $t("assets.b2c.otcShow.fiatTitle") : $t("personal.alert.fiatTitle") }}
      </div> -->
      <div class="alertText">{{ authTitleText }}</div>
      <div class="alertError gray-10-bd">
        <svg-icon :iconClass="!this.nickName ? 'icon-wrong-answer' : 'icon-right-answer'" className="icon-16"></svg-icon>
        <span class="alertError-text main-cl"> {{ this.$t("personal.alert.nickName") }}</span>
        <!-- <span v-if="!this.nickName">
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14"></use>
          </svg>
        </span>
        <span v-else>
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14_1"></use>
          </svg>
        </span> -->
      </div>
      <div class="alertError gray-10-bd">
        <svg-icon :iconClass="this.authLevel !== 1 ? 'icon-wrong-answer' : 'icon-right-answer'" className="icon-16"></svg-icon>
        <span class="alertError-text main-cl"> {{ this.$t("personal.alert.id") }}</span>
        <!-- <span v-if="this.authLevel !== 1">
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14"></use>
          </svg>
        </span>
        <span v-else>
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14_1"></use>
          </svg>
        </span> -->
      </div>
      <div class="alertError gray-10-bd">
        <svg-icon :iconClass="!this.google ? 'icon-wrong-answer' : 'icon-right-answer'" className="icon-16"></svg-icon>
        <span class="alertError-text main-cl">
          {{ this.$t("personal.alert.alertErrorTextGoogle") }}</span
        >

        <!-- <span v-if="!this.google">
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14"></use>
          </svg>
        </span>
        <span v-else>
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14_1"></use>
          </svg>
        </span> -->
      </div>
      <div class="alertError alertBot gray-10-bd" v-if="!enforceGoogleAuth">
        <svg-icon :iconClass="!this.sms ? 'icon-right-answer' : 'icon-wrong-answer'" className="icon-16"></svg-icon>
        <span class="alertError-text main-cl">
          {{ this.$t("personal.alert.alertErrorTextPhone") }}</span
        >
        <!-- <span v-if="!this.sms">
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14"></use>
          </svg>
        </span>
        <span v-else>
          <svg class="icon icon-14 alertError-icon" aria-hidden="true">
            <use xlink:href="#icon-a_14_1"></use>
          </svg>
        </span> -->
      </div>
    </c-alert>
    <c-dialog
      :showFlag="verifyFlag"
      titleText=""
      paddingTop="20px"
      @close="verifyClose"
      @confirm="verifyConfirm"
      :confirmLoading="verifyLoading"
      :confirmDisabled="verifyConfirmDisabled"
    >
      <div class="appealDialog">
        <c-inputLine
          v-if="googleCode || enforceGoogleAuth"
          maxLength="6"
          name="googleCode"
          inputType="text"
          :promptText="promptText2"
          :errorHave="true"
          :errorText="errorText2"
          :errorFlag="checkErrorFlag2"
          marginTop="0px"
          :value="checkValue2"
          @onchanges="inputChanges"
          newStyleFormat
        >
        </c-inputLine>
        <c-inputLine
          v-else-if="emailCode"
          maxLength="6"
          name="emailCode"
          inputType="text"
          :promptText="promptText3"
          :errorHave="true"
          :errorText="errorText3"
          :errorFlag="checkErrorFlag3"
          marginTop="0px"
          :value="checkValue3"
          @onchanges="inputChanges"
          newStyleFormat
        >
        </c-inputLine>
        <c-inputLine
          v-else
          v-show="smsCode"
          maxLength="6"
          name="smsCode"
          inputType="text"
          :promptText="promptText1"
          :errorHave="true"
          :errorText="errorText1"
          :errorFlag="checkErrorFlag1"
          marginTop="0px"
          :value="checkValue1"
          @onchanges="inputChanges"
          newStyleFormat
        >
          <!-- 获取验证码 -->
          <c-getCode
            name="phone"
            :autoStart="false"
            @click="getCodeClick"
            buttonName="loginGetcodeBtn"
          />
        </c-inputLine>
      </div>
    </c-dialog>
  </div>
</template>
<script>
import { imgMap, colorMap } from '@/utils';

export default {
  name: 'leaglTenderSet',
  data() {
    return {
      activeId: '',
      alertFlag: false,
      switchValue: false,
      imgMap,
      colorMap,
      dataList: [],
      isCapitalPwordSet: 0,
      sms: '',
      google: '',
      nickName: '',
      authLevel: 0, // 身份/实名认证状态，0、未审核，1、通过，2、未通过  3未认证
      verifyFlag: false,
      verifyLoading: false,
      verifyConfirmDisabled: true,
      // 验证框显示隐藏
      smsCode: false,
      googleCode: false,
      emailCode: false,
      // 验证码部分
      promptText1: this.$t('personal.label.smsCodeText'),
      errorText1: this.$t('personal.prompt.errorCode'),
      checkErrorFlag1: false,
      checkValue1: '',
      promptText2: this.$t('personal.label.googleCodeText'),
      errorText2: this.$t('personal.prompt.errorCode'),
      promptText3: this.$t('personal.label.emailCodeText'),
      errorText3: this.$t('personal.prompt.errorCode'),
      checkErrorFlag2: false,
      checkErrorFlag3: false,
      checkValue2: '',
      checkValue3: '',
    };
  },
  computed: {
    belongRoute() {
      let result = 'personal';
      if (this.$route.path.startsWith('/otc')) {
        result = 'otc';
      }
      return result;
    },
    fiatTradeOpen() {
      const base = this.$store.state.baseData.publicInfo;
      if (base && base.switch && base.switch.fiat_trade_open === '1') {
        return true;
      }
      return false;
    },
    authTitleText() {
      const text = this.enforceGoogleAuth
        ? 'personal.alert.enforceGoogleAuth'
        : 'assets.withdraw.safetyWarningError';
      return this.$t(text);
    },
    enforceGoogleAuth() {
      return this.$store.state.baseData.is_enforce_google_auth || 0;
    },
    sendSmsCode() {
      return this.$store.state.personal.sendSmsCode;
    },
    authIsPass() {
      return (
        this.nickName
        && this.authLevel === 1
        && (this.google || (!this.enforceGoogleAuth && this.sms))
      );
    },
    otcPaymentFind() {
      return this.$store.state.personal.otcPaymentFind;
    },
    otcPaymentDelete() {
      return this.$store.state.personal.otcPaymentDelete;
    },
    otcPaymentOpen() {
      return this.$store.state.personal.otcPaymentOpen;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    isCanModifyName() {
      return this.userInfo && Number(this.userInfo.userCompanyInfo.status) === 0;
    },
    excheifFlag() {
      return this.$store.state.baseData.exchief_project_switch;
    },
  },
  watch: {
    otcPaymentFind(otcPaymentFind) {
      if (otcPaymentFind !== null) {
        this.dataList = otcPaymentFind.data;
      }
    },
    otcPaymentDelete(otcPaymentDelete) {
      if (otcPaymentDelete !== null) {
        this.activeId = '';
        if (otcPaymentDelete.text === 'success') {
          this.verifyFlag = false;
          this.$bus.$emit('tip', {
            text: otcPaymentDelete.msg,
            type: 'success',
          });
          this.$store.dispatch('resetType');
          this.$store.dispatch('otcPaymentFind');
        } else {
          this.$bus.$emit('tip', { text: otcPaymentDelete.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    otcPaymentOpen(otcPaymentOpen) {
      if (otcPaymentOpen !== null) {
        if (otcPaymentOpen.text === 'success') {
          this.$bus.$emit('tip', { text: otcPaymentOpen.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.$store.dispatch('otcPaymentFind');
        } else {
          this.$bus.$emit('tip', { text: otcPaymentOpen.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    userInfo(userInfo) {
      if (userInfo !== null) {
        this.isCapitalPwordSet = userInfo.isCapitalPwordSet;
        this.google = !!userInfo.googleStatus;
        this.sms = !!userInfo.isOpenMobileCheck;
        this.nickName = userInfo.nickName;
        this.authLevel = userInfo.authLevel;
        this.googleCode = !!Number(userInfo.googleStatus);
        this.smsCode = !!Number(userInfo.isOpenMobileCheck);
        this.emailCode = !!userInfo.email;
      }
    },
    sendSmsCode(sendSmsCode) {
      if (sendSmsCode !== null) {
        if (sendSmsCode.text === 'success') {
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'success' });
          this.$store.dispatch('resetType');
        } else {
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'error' });
          this.$store.dispatch('resetType');
          this.$bus.$emit('getCode-clear', 'phone');
        }
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    codeFlag(val) {
      return this.$store.state.regExp.verification.test(val);
    },
    init() {
      this.$store.dispatch('otcPaymentFind');
      // 获取 userinfo
      this.$store.dispatch('getUserInfo');

      const { userInfo } = this.$store.state.baseData;
      if (userInfo !== null) {
        this.isCapitalPwordSet = userInfo.isCapitalPwordSet;
        this.google = !!userInfo.googleStatus;
        this.sms = !!userInfo.isOpenMobileCheck;
        this.nickName = userInfo.nickName;
        this.authLevel = userInfo.authLevel;
      }
    },
    resloveText(obj) {
      const {
        bankName, bankOfDeposit, account, userName,
      } = obj;
      let name = '';

      if (this.$store.state.baseData.userInfo) {
        name = this.$store.state.baseData.userInfo.realName;
      }
      if (!this.isCanModifyName) {
        name = userName;
      }
      if (this.excheifFlag) {
        name = userName;
      }
      const arr = [bankName, bankOfDeposit, account, name].filter(item => item);
      return arr.join(' &nbsp; &nbsp; &nbsp; ');
    },
    alertClose() {
      this.alertFlag = false;
    },
    alertGo() {
      const currentHost = process.env.VUE_APP_COMPILE_ENV === 'prod' ? 'https://mal.io' : 'https://test.mal.coffee:8734';
      window.location.href = `${currentHost}/personal/user-account`;
      // this.$router.push('/personal/userManagement');
    },
    switchChange(id, isOpen) {
      let open = '0';
      if (isOpen === '1') {
        open = 0;
      } else {
        open = 1;
      }
      const info = { id: Number(id), isOpen: open };
      this.$store.dispatch('otcPaymentOpen', info);
    },
    click(id, name) {
      if (!this.authIsPass) {
        this.alertFlag = true;
        return;
      }

      if (name === 'delete') {
        if (this.activeId !== id) {
          this.activeId = id;
          // const info = { id };
          // this.$store.dispatch('otcPaymentDelete', info);
        }
        this.verifyFlag = true;
      } else if (name === 'modify') {
        this.$router.push({
          path: `/${this.belongRoute}/setUp`,
          query: { paymentId: id.id },
        });
        // 传参
        const info = { obj: id, set: 1 }; // set 0为正常添加 1为修改
        this.$store.dispatch('setPayment', info);
      }
    },
    btnLink(name) {
      if (this.authIsPass) {
        if (name === 'modifySettings') {
          this.$router.push({ path: `/${this.belongRoute}/modifySettings`, query: {} });
        } else {
          this.$router.push({ path: `/${this.belongRoute}/setUp`, query: {} });
        }
      } else {
        this.alertFlag = true;
      }
    },
    verifyClose() {
      this.checkValue1 = '';
      this.checkValue2 = '';
      this.checkValue3 = '';
      this.verifyFlag = false;
    },
    getCodeClick() {
      this.$bus.$emit('getCode-start', 'phone');
      const info = { operationType: 28 };
      this.$store.dispatch('sendSmsCode', info);
    },
    verifyConfirm() {
      const id = this.activeId;
      const smsAuthCode = this.checkValue1;
      const googleCode = this.checkValue2;
      const emailCode = this.checkValue3;
      if (!this.codeFlag(googleCode) && !this.codeFlag(emailCode) && !this.codeFlag(smsAuthCode)) {
        return;
      }
      const info = {
        id,
        smsAuthCode,
        googleCode,
        emailCode,
      };
      this.$store.dispatch('otcPaymentDelete', info);
    },
    inputChanges(value, name) {
      switch (name) {
        case 'smsCode':
          this.checkValue1 = value;
          if (this.codeFlag(value)) {
            this.checkErrorFlag1 = false;
            this.verifyConfirmDisabled = false;
          } else {
            this.checkErrorFlag1 = true;
            this.verifyConfirmDisabled = true;
          }
          break;
        case 'emailCode':
          this.checkValue3 = value;
          if (this.codeFlag(value)) {
            this.checkErrorFlag3 = false;
            this.verifyConfirmDisabled = false;
          } else {
            this.checkErrorFlag3 = true;
            this.verifyConfirmDisabled = true;
          }
          break;
        default:
          this.checkValue2 = value;
          if (this.codeFlag(value)) {
            this.checkErrorFlag2 = false;
            this.verifyConfirmDisabled = false;
          } else {
            this.checkErrorFlag2 = true;
            this.verifyConfirmDisabled = true;
          }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.legal-tender-set {
  width: 100%;
  min-height: 800px;

  .user-management-child-header {
    font-size: 14px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }

  .user-management-main {
    width: 100%;
    float: left;

    .user-management-main ul li {
      width: 100%;
      float: left;
    }

    .li-icon {
      float: left;
      margin: 25px 20px;
      transform: translate(0, 8px);
    }

    .otcPayIconClass {
      font-size: 20px;
      background-color: #fff;
    }

    .subTextIndent {
      margin-left: 38px;
    }

    .operateArea {
      display: flex;
      gap: 32px;
      align-items: center;
    }

    .li-div {
      float: left;
      width: calc(100% - 66px);;
      height: 80px;
      box-sizing: border-box;
      border-bottom-style: solid;
      border-bottom-width: 1px;
      font-size: 14px;
      position: relative;
    }

    .li-div:last-of-type(1) {
      border-bottom-style: none;
      border-bottom-width: 0px;
    }

    .li-div p:nth-of-type(1) {
      margin-top: 20px;
    }

    .li-divs p:nth-of-type(1) {
      line-height: 24px;
    }

    .li-div p:nth-of-type(1).switchBottom,
    .li-div p:nth-of-type(1).switchBottomChecked {
      margin-top: 0;
    }

    .li-div p:nth-of-type(1).none {
      margin-top: 32px;
    }

    .li-div p:nth-of-type(2) {
      margin-top: 10px;
      font-size: 12px;
      width: 80%;
    }

    .li-div-right {
      margin-left: 64px;
    }

    .li-title img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .li-fun {
      float: right;
      font-size: 12px;
      cursor: pointer;
    }

    .li-right {
      position: absolute;
      top: 32px;
      right: 21px;
      float: right;

      .switchWrap {
        float: right;
        top: 3px;
        margin: 0 6px;
      }

      .common-button {
        top: -5px;
      }

      .user-button {
        font-size: 12px;
        margin-top: -10px;
      }
    }
  }

  .alertTitle {
    margin-bottom: 15px;
  }

  .alertText {
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    padding: 16px 24px 24px;
    box-sizing: border-box;
  }
  .alertError {
    height: 40px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding: 10px 24px;
    box-sizing: border-box;
    .alertError-text {
      font-size: 14px;
      line-height: 20px;
      margin-left: 8px;
    }
    // .alertError-icon {
    //   float: right;
    //   margin-top: 12px;
    // }
  }

  .alertBot {
    margin-bottom: 16px;
  }
}

.carp-coin {
  background: rgba(#24a0f5, 0.15);
  border: 0 solid #24a0f5;
  border-radius: 2px;
  color: #24a0f5;
  padding: 0 7px;
  line-height: 20px;
  margin-left: 8px;
}
</style>
